export class UnauthorizedError extends Error {
	constructor(message = 'Unauthorized access', originalError = null) {
		super(message);
		this.name = 'UnauthorizedError';
		this.statusCode = 401;
		this.originalError = originalError;

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, UnauthorizedError);
		}
	}
}
